import { useQuery } from '@tanstack/react-query';
import { goodsService } from 'shared/src/api';
import { useGoodsSno } from '../hooks/useGoodsSno';
import { queryKey } from '../constant/queryKey';

export const useGoodsCoupon = () => {
  const goodsSno = useGoodsSno();
  return useQuery({
    queryKey: queryKey.goodsCoupon(goodsSno),
    queryFn: () => goodsService.getGoodsCoupon(goodsSno),
  });
};
